import { ArrayParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clustersGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.competitorIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.competitorNetworkIds]: ArrayParam
}
